import { rgba } from 'polished';
import styled, { css, DefaultTheme } from 'styled-components';

type TabProps = {
  $isActive?: boolean;
};

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${rgba(theme.colors.neutralSilver20, 0.4)};
    border: 1px solid ${theme.colors.neutralSilver10};
    border-radius: 8px;
    display: inline-flex;
  `}
`;

const tabModifiers = (theme: DefaultTheme) => ({
  active: css`
    background: ${theme.colors.globalWhite100};
    border: 1px solid ${theme.colors.neutralSilver10};
    border-radius: 8px;

    color: ${theme.colors.brandPrimary70};
    font-weight: 500;
  `,
});

export const Tab = styled.button<TabProps>`
  ${({ theme, $isActive }) => css`
    border: none;
    padding: 8px 32px;
    cursor: pointer;

    font-weight: 400;
    font-size: 1.6rem;
    line-height: 2.6rem;
    color: ${theme.colors.neutralSilver50};
    flex-grow: 1;

    
    ${!$isActive && css`
      background-color: transparent;
    `}

    ${$isActive && tabModifiers(theme).active}


    @media (max-width: 400px) {
      padding: 6px 24px;
      font-size: 1.4rem;
    }
  `}
`;
